module.exports = __webpack_public_path__ + "img/charging-hub-disabled-semipublic.29e68d6b.svg";